import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { UsersComponent } from '../../pages/users/users.component';
import { RoleAccountGuard } from '../../guards/role-account.guard';

export const usersRoutes: Routes = [
  {
    path: 'settings/users',
    component: UsersComponent,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.users', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/users/:reference',
    component: UsersComponent,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.users', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/users/add',
    component: UsersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.drafts', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'settings/users/edit/:reference',
    component: UsersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.drafts', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  }


];

export function getFilteredUsersRoutes(accountType: string, role: string): Routes {
  return usersRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
